<template>
    <div>
        <!-- Dialogo card vinculado con acciones del dashboard-->
        <v-dialog v-model="isActive" transition="dialog-bottom-transition" scrollable
            :fullscreen="$vuetify.breakpoint.mobile" :width="width">
            <v-card flat class="rounded-0">
                <v-card flat elevation="0" height="60" class="rounded-0">
                    <v-app-bar flat color="white" height="60">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                                    @keydown.esc="cerrarDialogo">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar</span>
                        </v-tooltip>
                        <v-toolbar-title class="pr-1 text-h6 font-weight-bold primary--text"
                            style="white-space: normal; word-break: break-word;">{{ titulo }}</v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card-text>
                    <ExpansionPanel v-if="tipo == 'datosafi'" :items="itemsPersonales"></ExpansionPanel>
                    <FormCambiarPass v-if="tipo == 'pass'" @cambioPass="cerrarDialogo" />
                    <FormNuevoTurno v-if="tipo == 'turno'" @cerrar="cerrarDialogo" />
                </v-card-text>
                <v-card-actions v-if="tipo == 'datosafi'">
                    <v-col class="d-flex justify-end">
                        <v-btn outlined class="pa-5" @click="guardarTemporalmente" color="primary" dark>
                            <v-icon class="mr-2">mdi-send-outline</v-icon>enviar trámite</v-btn>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import DialogoTurno from '@/components/dialogos/DialogoTurno.vue'

//Expansion Panel
import ExpansionPanel from '@/components/panels/ExpansionPanelGen.vue'

//Formularios
import FormPreAfi from '@/components/forms/FormPreAfi.vue'
import FormDatosAfi from '@/components/forms/FormDatosAfi.vue'
import FormNuevoTurno from '@/components/forms/FormNuevoTurno.vue'
import FormCambiarPass from '@/components/forms/FormCambiarPass.vue'
import FormFotoCarnetPers from '@/components/forms/FormFotoCarnetPers.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'DialogoCard',

    components: {
        //componentes
        ExpansionPanel,

        //Formularios
        FormPreAfi,
        FormDatosAfi,
        FormNuevoTurno,
        FormCambiarPass,
        FormFotoCarnetPers,

        //Dialogos
        DialogoTurno

    },
    data() {
        return {
            isActive: false,
            /* 
            // ExpansionPanel items modificar datos afiliado
            */
            //{ title: 'DNI (frente y dorso)', icon: 'mdi-card-account-details-outline', color: 'primary', component: 'InputArchivos' },
            itemsPersonales: [
                { title: 'Foto carnet', icon: 'mdi-camera-outline', color: 'primary', component: 'FormFotoCarnetPers' },
                /*                 { title: 'Editar mi foto de legajo', icon: 'mdi-camera-outline', color: 'primary', component: 'FormFotoyArch' }, */
                { title: 'Editar mis datos personales', icon: 'mdi-account-edit-outline', color: 'primary', component: 'FormDatosAfi' },
                {
                    title: 'DNI (frente y dorso)', icon: 'mdi-card-account-details-outline', color: 'primary', component: 'InputArchGen',
                    props: {
                        op: 'personales',
                        label: 'Debera cargar su documento de frente y dorso ',
                        rules: 'required|ext:jpg,pdf,jpeg',
                        limite: 2,
                    }
                },
            ],

            itemsFamiliares: [
                {
                    title: 'Datos de conyuge/conviviente', icon: 'mdi-account-outline', component: 'FormFamiliar', color: 'primary'
                },
                {
                    title: 'DNI de conyuge/conviviente (frente y dorso)', icon: 'mdi-card-account-details-outline', component: 'InputArchGen', color: 'primary', props: {
                        op: 'personales',
                        label: 'Debera cargar frente y dorso de su familiar',
                        subtitle: 'Debera cargar frente y dorso de su familiar',
                        rules: 'required|ext:jpg,pdf,jpeg',
                        limite: 2,
                    }
                },
                { title: 'Certificado de matrimonio/convivencia/concubinato', icon: 'mdi-file-document-multiple-outline', component: 'InputArchivos', color: 'primary' },
            ],

        }
    },
    props: ['titulo', 'tipo', 'width'],

    computed: {
        ...mapGetters('dataUser', ['fototmp']),
        ...mapGetters('itemEdit', ['itemSelected']),
        ...mapGetters('notificaciones', ['loading']),
    },
    methods: {
        ...mapActions('dataUser', ['precargaFoto', 'crearFormDataPersonales']),
        ...mapActions('itemEdit', ['vaciarItem']),
        ...mapActions('turnos', ['getTurnosActivos']),


        cerrarDialogo() {

            // cierra el dialogo y elimina las variables almacenadas temporalmente
            // en el store
            if (this.fototmp) {
                this.precargaFoto('')
            }
            //se vacia el store itemEdit
            if (this.itemSelected) {
                this.vaciarItem()
            }
            this.isActive = false
        },
        abrirDialogo() {
            this.isActive = true
        },
        guardarTemporalmente() {
            this.crearFormDataPersonales()
        }
    }

}

</script>